const scopes = ['profile', 'email', 'openid', 'tmtcfiscaldoc']
export default scopes
